import React from 'react';

const BackgroundCanvas = () => {
    return (
        <div className="fixed top-0 left-0 w-full h-full -z-10">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-pink-50 opacity-70"></div>
            <div className="absolute inset-0 bg-pattern"></div>
        </div>
    );
};

export default BackgroundCanvas;